import React from 'react';
import { Box, Typography, CircularProgress, Paper, Grid, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const ResultPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.text.primary,
  borderRadius: '15px',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.02)',
  },
  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

const StatBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
}));

const QuizResults = ({ percentage, correctAnswers, incorrectAnswers, velocity }) => {
  const getColor = (percent: number) => {
    if (percent < 50) return '#FF4136'; // Rojo para bajo rendimiento
    if (percent < 80) return '#FFDC00'; // Amarillo para rendimiento medio
    return '#2ECC40'; // Verde para alto rendimiento
  };

  const color = getColor(percentage);
  const totalQuestions = correctAnswers + incorrectAnswers;

  return (
    <ResultPaper elevation={3}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box position="relative" display="inline-flex">
            <CircularProgress
              variant="determinate"
              value={percentage}
              size={200}
              thickness={5}
              sx={{ color: color }}
            />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography variant="h4" component="div" fontWeight="bold" sx={{ color }}>
                {`${percentage}%`}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h5" component="div" gutterBottom fontWeight="bold">
            Resultados del Quiz
          </Typography>
          <IconWrapper>
            {percentage >= 80 ? (
              <EmojiEventsIcon sx={{ fontSize: 60, color: 'gold' }} />
            ) : percentage >= 50 ? (
              <CheckCircleIcon sx={{ fontSize: 60, color: '#2ECC40' }} />
            ) : (
              <CancelIcon sx={{ fontSize: 60, color: '#FF4136' }} />
            )}
          </IconWrapper>
          <StatBox>
            <CheckCircleIcon sx={{ color: '#2ECC40', mr: 1 }} />
            <Typography variant="body1">
              Correctas: <strong>{correctAnswers}</strong>
            </Typography>
          </StatBox>
          <StatBox>
            <CancelIcon sx={{ color: '#FF4136', mr: 1 }} />
            <Typography variant="body1">
              Incorrectas: <strong>{incorrectAnswers}</strong>
            </Typography>
          </StatBox>
          <StatBox>
            <HelpOutlineIcon sx={{ color: 'grey', mr: 1 }} />
            <Typography variant="body1">
              Total de preguntas: <strong>{totalQuestions}</strong>
            </Typography>
          </StatBox>

          <Tooltip title="Porcentaje de respuestas correctas" arrow>
            <Typography variant="h6" fontWeight="bold" sx={{ color, mt: 2 }}>
              Rendimiento: {percentage}%
            </Typography>
          </Tooltip>
          {velocity && velocity > 0 ? (
            <Typography variant="h6" fontWeight="bold" sx={{  mt: 2 }}>
              Velocidad de lectura: <strong>{velocity} p/m</strong>
            </Typography>

          ):null}
        </Grid>
      </Grid>
    </ResultPaper>
  );
};

export default QuizResults;

